exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(true);
// Module
exports.push([module.id, ".svg__svgView___3CcOh {\n  user-select: none;\n  -webkit-user-select: none;\n}\n", "",{"version":3,"sources":["svg.less"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yBAAyB;AAC3B","file":"svg.less","sourcesContent":[".svgView {\n  user-select: none;\n  -webkit-user-select: none;\n}\n"]}]);

// Exports
exports.locals = {
	"svgView": "svg__svgView___3CcOh"
};